import { render, staticRenderFns } from "./dragDropButtonBlock.vue?vue&type=template&id=6d4d6284&"
import script from "./dragDropButtonBlock.vue?vue&type=script&lang=js&"
export * from "./dragDropButtonBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports